<template>
  <el-dialog :visible.sync="isShow" :width="width" :before-close="beforeClose">
    <div slot="title">
      <span>{{ title }}</span>
      <el-tooltip class="item" placement="right-start">
        <ol slot="content">
          <li>导出的数据在线保存一个月，支持重复下载</li>
          <li>
            导出的数据超出一个月后，建议重新点击【导出数据】选择对应的数据进行导出
          </li>
        </ol>
        <i class="el-icon-info"></i>
      </el-tooltip>
    </div>
      <!-- 列表 -->
      <QS-common-table
        :data="tableData"
        :columns="columns"
        :pagination="paginationData"
        @change="paginationChange"
        v-loading="loading"
      />
  </el-dialog>
</template>

<script>
import selectOptionDict from '@/store/dict/selectOptionDict.js'
import { asyncExportList } from '@/api/domain/orders.js'
import { exportDownloadFile } from '@/api/export.js'
import { operateMaxShowLength } from '@/store/dict/config'

export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '824px',
    },
    title: {
      type: String,
      default: '导出列表',
    },
    // 导出列表数据接口
    exportListApi: {
      type: Function,
      default: asyncExportList,
    },
    // 下载详情数据接口
    downLoadApi: {
      type: Function,
      default: exportDownloadFile,
    },
    fileName: {
      type: String,
      default: '导出详情',
    },
    taskType: {
      type: Number,
    },
  },
  computed: {
    isShow() {
      return this.dialogVisible
    },
  },
  mounted() {
    this.$emit('init', {
      getTableData: (para) => this.getTableData(para),
    })
  },
  data() {
    return {
      columns: [
        {
          name: 'gmtCreate',
          columnProps: {
            label: '导出时间',
            prop: 'gmtCreate',
            width: '220px',
          },
        },
        {
          name: 'userName',
          columnProps: {
            label: '操作人名称',
            prop: 'userName',
          },
        },
        {
          name: 'userAccount',
          columnProps: {
            label: '操作人账号',
            prop: 'userAccount',
          },
        },
        {
          name: 'taskStatus',
          columnProps: {
            label: '导出状态',
            prop: 'taskStatus',
          },
          getText: ({ row }) => selectOptionDict.EXPORT_STATUS[row.taskStatus],
        },
        {
          name: 'operate',
          columnProps: {
            label: '导出详情',
          },
          maxShowLength: operateMaxShowLength,
          type: 'operate',
          getOperateList: ({ row }) => {
            const detail = [{
              name: 'detail', label: this.fileName, action: () => this.down(row),
            }]
            return detail
          },
        },
      ],
      tableData: [],
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [10, 20, 30, 50],
      },
      loading: false,
    }
  },
  methods: {
    down(row) {
      // 3-成功
      if (Number(row.taskStatus) !== 3) {
        this.$message.error(`${selectOptionDict.EXPORT_STATUS[row.taskStatus]}的任务不能下载`)
        return
      }
      this.$message.success('开始下载')
      const { taskId } = row
      this.downLoadApi({ taskId }).then((data) => {
        if (!data) return
        const url = window.URL.createObjectURL(
          new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          }),
        )
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', this.fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },
    // taskType(任务类型) 1-逾期明细 2-风控记录 3-车辆运营 4-客户运营
    async getTableData(para) {
      this.loading = true
      const params = {
        ...para,
        taskType: this.taskType,
      }
      const { code, data } = await this.exportListApi(params)
      this.loading = false
      if (code !== 1) return
      this.tableData = data?.items || []
      this.paginationData.total = data?.totalNum || 0
    },
    paginationChange({ pagination }) {
      const { pageNum, pageSize } = pagination
      this.paginationData.pageNum = pageNum
      this.paginationData.pageSize = pageSize
      this.getTableData({ pageNum, pageSize })
    },
    beforeClose() {
      this.$emit('close')
    },
  },
}
</script>

